export const menus = [
  {
    menuId: "1000",
    parentId: "0",
    menuName: "首页",
    menuCode: "HomePage",
    icon: "zyd-icon-shendan",
    menuLink: "/HomePage",
    menuType: 1,
    children: [],
    isChecked: null,
    sorted: 1
  },
  {
    menuId: "1003",
    parentId: "0",
    menuName: "调度工作台",
    menuCode: "SchedulingWorkbench",
    icon: "zyd-icon-diaodu",
    menuLink: "/SchedulingWorkbench",
    menuType: 1,
    children: [
      {
        menuId: "100301",
        parentId: "1003",
        menuName: "订单调度",
        menuCode: "OrderScheduling",
        icon: null,
        menuLink: "/SchedulingWorkbench/OrderScheduling/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 1
      },
      {
        menuId: "100302",
        parentId: "1003",
        menuName: "订单改派",
        menuCode: "OrderReassignment",
        icon: null,
        menuLink: "/SchedulingWorkbench/OrderReassignment/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 2
      },
      {
        menuId: "100303",
        parentId: "1003",
        menuName: "司机排班",
        menuCode: "DriverWorkforceManagement",
        icon: null,
        menuLink: "/FleetLeaderWorkbench/DriverWorkforceManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 4
      },
      {
        menuId: "100304",
        parentId: "1003",
        menuName: "调度资源配置",
        menuCode: "SchedulingResourceManagement",
        icon: null,
        menuLink: "/SchedulingWorkbench/SchedulingResourceManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 5
      }
    ],
    permissions: [],
    isChecked: null,
    sorted: 3
  },
  {
    menuId: "1004",
    parentId: "0",
    menuName: "车队长工作台",
    menuCode: "FleetLeaderWorkbench",
    icon: "zyd-icon-cheduiz",
    menuLink: "/FleetLeaderWorkbench",
    menuType: 1,
    children: [
      {
        menuId: "100401",
        parentId: "1004",
        menuName: "实时监控",
        menuCode: "RealtimeMonitoring",
        icon: null,
        menuLink: "/FleetLeaderWorkbench/RealtimeMonitoring/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 1
      },
      {
        menuId: "100402",
        parentId: "1004",
        menuName: "车辆GPS监控",
        menuCode: "DriverTransitMonitoring",
        icon: null,
        menuLink: "/FleetLeaderWorkbench/DriverTransitMonitoring/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 2
      },
      {
        menuId: "100403",
        parentId: "1004",
        menuName: "平台司机管理",
        menuCode: "PlatformDriverManagement",
        icon: null,
        menuLink: "/FleetLeaderWorkbench/PlatformDriverManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 3
      },
      {
        menuId: "100404",
        parentId: "1004",
        menuName: "临调司机管理",
        menuCode: "TemporaryAdjustmentDriverManagement",
        icon: null,
        menuLink: "/FleetLeaderWorkbench/TemporaryAdjustmentDriverManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 4
      },
      {
        menuId: "100406",
        parentId: "1004",
        menuName: "司机流失预警",
        menuCode: "DriverChurnWarning",
        icon: null,
        menuLink: "/FleetLeaderWorkbench/DriverChurnWarning/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 5
      }
    ],
    permissions: [],
    isChecked: null,
    sorted: 4
  },
  {
    menuId: "1005",
    parentId: "0",
    menuName: "客服工作台",
    menuCode: "CustomerServiceWorkbench",
    icon: "zyd-icon-kefu",
    menuLink: "/CustomerServiceWorkbench",
    menuType: 1,
    children: [
      {
        menuId: "100501",
        parentId: "1005",
        menuName: "运单管理",
        menuCode: "OrderQuery",
        icon: null,
        menuLink: "/CustomerServiceWorkbench/OrderQuery/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 1
      },
      {
        menuId: "100503",
        parentId: "1005",
        menuName: "客服审核",
        menuCode: "PendingPriceOrder",
        icon: null,
        menuLink: "/CustomerServiceWorkbench/PendingPriceOrder/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 2
      },
      {
        menuId: "100504",
        parentId: "1005",
        menuName: "回单订单管理",
        menuCode: "ReturnOrder",
        icon: null,
        menuLink: "/CustomerServiceWorkbench/ReturnOrder/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 3
      },
      {
        menuId: "100502",
        parentId: "1005",
        menuName: "新司机订单跟单",
        menuCode: "NewDriverOrderFollowUp",
        icon: null,
        menuLink: "/CustomerServiceWorkbench/NewDriverOrderFollowUp/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 4
      },
      {
        menuId: "100506",
        parentId: "1005",
        menuName: "投诉建议管理",
        menuCode: "ComplaintSuggestionManagement",
        icon: null,
        menuLink: "/CustomerServiceWorkbench/ComplaintSuggestionManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 5
      }
    ],
    permissions: [],
    isChecked: null,
    sorted: 5
  },

  {
    menuId: "1007",
    parentId: "0",
    menuName: "审批中心",
    menuCode: "ApprovalCenter",
    icon: "zyd-icon-shendan",
    menuLink: "/ApprovalCenter",
    menuType: 1,
    children: [
      {
        menuId: "100701",
        parentId: "1007",
        menuName: "司机信息审批",
        menuCode: "DriverInformationApproval",
        icon: null,
        menuLink: "/ApprovalCenter/DriverInformationApproval/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 1
      },
      {
        menuId: "100703",
        parentId: "1007",
        menuName: "订单取消审批",
        menuCode: "OrderCancelApproval",
        icon: null,
        menuLink: "/ApprovalCenter/OrderCancelApproval/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 2
      }
    ],
    permissions: [],
    isChecked: null,
    sorted: 7
  },
  {
    menuId: "1006",
    parentId: "0",
    menuName: "财务管理",
    menuCode: "FinancialManagement",
    icon: "zyd-icon-caiwu",
    menuLink: "/FinancialManagement",
    menuType: 1,
    children: [
      {
        menuId: "100601",
        parentId: "1006",
        menuName: "钱包管理",
        menuCode: "WalletManagement",
        icon: null,
        menuLink: "/FinancialManagement/WalletManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 1
      },
      {
        menuId: "100603",
        parentId: "1006",
        menuName: "开票管理",
        menuCode: "InvoicesApply",
        icon: null,
        menuLink: "/FinancialManagement/InvoicesApply/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 2
      }
    ],
    permissions: [],
    isChecked: null,
    sorted: 6
  },
  {
    menuId: "1009",
    parentId: "0",
    menuName: "业务规则管理",
    menuCode: "ServiceConfig",
    icon: "zyd-icon-caiwu",
    menuLink: "/ServiceConfig",
    menuType: 1,
    children: [
      {
        menuId: "100901",
        parentId: "1009",
        menuName: "承运线路管理",
        menuCode: "CarrierRouteConfig",
        icon: null,
        menuLink: "/ServiceConfig/CarrierRouteConfig/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 1
      },
      {
        menuId: "100902",
        parentId: "1009",
        menuName: "计费规则配置",
        menuCode: "OrderBillingRuleConfig",
        icon: null,
        menuLink: "/ServiceConfig/OrderBillingRuleConfig/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 2
      },
      {
        menuId: "100903",
        parentId: "1009",
        menuName: "基础业务规则配置",
        menuCode: "BasicBusinessRuleConfig",
        icon: null,
        menuLink: "/ServiceConfig/BasicBusinessRuleConfig/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 3
      }
    ],
    permissions: [],
    isChecked: null,
    sorted: 9
  },
  {
    menuId: "1010",
    parentId: "0",
    menuName: "系统管理",
    menuCode: "SystemManagement",
    icon: "zyd-icon-xitong",
    menuLink: "/SystemManagement",
    menuType: 1,
    children: [
      {
        menuId: "101001",
        parentId: "1010",
        menuName: "代理商管理",
        menuCode: "AgentManagement",
        icon: null,
        menuLink: "/SystemManagement/AgentManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 1
      },
      {
        menuId: "101002",
        parentId: "1010",
        menuName: "服务商管理",
        menuCode: "ServiceManagement",
        icon: null,
        menuLink: "/SystemManagement/ServiceManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 2
      },
      {
        menuId: "101003",
        parentId: "1010",
        menuName: "员工管理",
        menuCode: "StaffManagement",
        icon: null,
        menuLink: "/SystemManagement/StaffManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 3
      },
      {
        menuId: "101004",
        parentId: "1010",
        menuName: "字典管理",
        menuCode: "DictManagement",
        icon: null,
        menuLink: "/SystemManagement/DictManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 3
      },
      {
        menuId: "101005",
        parentId: "1010",
        menuName: "角色权限管理",
        menuCode: "RolePermissionManagement",
        icon: null,
        menuLink: "/SystemManagement/RolePermissionManagement/index",
        menuType: 1,
        children: [],
        permissions: [],
        isChecked: null,
        sorted: 5
      }
    ],
    permissions: [],
    isChecked: null,
    sorted: 10
  }
];
export const permissions = getPermissions();
function getPermissions() {
  let permissions = [];
  menus.forEach((item) => {
    permissions.push(item.menuCode);
    if (item.children && item.children.length > 0) {
      item.children.forEach((item) => {
        permissions.push(item.menuCode);
      });
    }
  });
  return permissions;
}
